import type { ReportTicket } from "./metrics";

type Cell = string | number | boolean | undefined;

// A cell that starts with one of these is run as a formula by spreadsheet programs, so it is made plain text.
const FORMULA_START = /^[=+\-@\t\r]/;

export function csvCell(value: Cell): string {
  const text = value === undefined ? "" : String(value);
  const safe = typeof value === "string" && FORMULA_START.test(text) ? `'${text}` : text;
  return /[",\r\n]/.test(safe) ? `"${safe.replace(/"/g, '""')}"` : safe;
}

export function toCsv(rows: readonly (readonly Cell[])[]): string {
  return `${rows.map((row) => row.map(csvCell).join(",")).join("\r\n")}\r\n`;
}

const HEADERS = [
  "Raised",
  "Raised by",
  "Company",
  "Business unit",
  "Feature",
  "Severity",
  "Pricing plan",
  "Ticket type",
  "Been to CS huddle",
  "Team",
  "Engineer",
  "Status",
  "Closed",
  "Business days to close",
  "Picked up",
  "In progress",
  "Waiting on customer",
  "Waiting on CS",
  "Jira",
  "Source",
  "Details",
];

// The filtered tickets as a CSV, with each ticket's text from `details` (by ticket ID).
export function ticketCsv(tickets: readonly ReportTicket[], details: Readonly<Record<string, string>>): string {
  return toCsv([
    HEADERS,
    ...tickets.map((row) => [
      row.raisedAt,
      row.raiser,
      row.company,
      row.businessUnit,
      row.feature,
      row.severity,
      row.pricingPlan,
      row.ticketType,
      row.huddle,
      row.team,
      row.engineer,
      row.status,
      row.closedAt,
      row.daysToClose === undefined ? undefined : Number(row.daysToClose.toFixed(2)),
      row.pickedUpAt,
      row.inProgressAt,
      row.waitingCustomerAt,
      row.waitingCsAt,
      row.jiraKey,
      row.source === "sheet" ? "Master Sheet" : "Triage Desk",
      details[row.id],
    ]),
  ]);
}
